<template>
    <div class="popup pop-sharing" id="div_pop-sharing">
        <div class="pop-wrap">
            <div class="sharing-bg">
                <p><strong>SNS</strong>에 공유해보세요.</p>
                <button class="btn-close-pop" @click="closeSelf">닫기</button>
                <ul class="sns-list">
                    <!--<li class="kstory-icon">-->
                        <!--<a href="javascript:void(0)" @click.stop="sendLinkKakao"><img src="/images/icon/icon-sharing-kstory-big.svg" alt="카카오스토리 공유하기" style="cursor: pointer;" class="sns-pop" /><p>카카오스토리</p></a>-->
                    <!--</li>-->
                    <li class="nblog-icon">
                        <a href="javascript:void(0)" @click.stop="sendLinkNaver"><img src="/images/icon/icon-sharing-nblog-big.svg" alt="네이버블로그 공유하기" style="cursor: pointer;" class="sns-pop" /><p>블로그</p></a>
                    </li>
                    <li class="fb-icon">
                        <a href="javascript:void(0)" @click.stop="sendLinkFaceBook"><img src="/images/icon/icon-sharing-fb-big.svg" alt="페이스북 공유하기" style="cursor: pointer;"  class="sns-pop" /><p>페이스북</p></a>
                    </li>
                    <li class="tw-icon">
                        <a href="javascript:void(0)" @click.stop="sendLinkTwitter"><img src="/images/icon/tw-icon.svg" alt="트위터 공유하기" style="cursor: pointer;" class="sns-pop" /><p>트위터</p></a>
                    </li>
                </ul>
                <div class="link-copy">
                    <input type="text" id="short-url" class="link-txt" :value="shortUrl" readonly/>
                    <button type="button" style="margin-top:1px" class="btn btn-white" @click.prevent="copyLink()">URL복사</button>
                </div>
            </div>
            <div class="Qr">
                <div class="inner">
                    <div id="qrcode" class="Qrimg"></div>
                    <div class="Qrtext"><p><strong>QR코드</strong>를 스캔해주세요.</p></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                shortUrl: '',       // 이야기자료 Short URL
                viewUrl: '',        // 이야기자료 URL
            }
        },
        created(){
            // 전역 이벤트 감지
            this.$bus.$on('open-sns-share-modal-popup', this.openSnsShareModalPopup); // 팝업 보이기
        },
        methods: {
            openSnsShareModalPopup(short_url, view_url){
                this.shortUrl = short_url;
                this.viewUrl = view_url;


                // qrcode 생성
                this.qrcodeMake(this.viewUrl);

                $(".pop-sharing").fadeIn("fast");
            },
            closeSelf() {
                $(".pop-sharing").fadeOut("fast");
            },
            sendLinkFaceBook() {
                window.open('https://www.facebook.com/sharer/sharer.php?u=' +encodeURIComponent(this.viewUrl)+'&t='+encodeURIComponent(this.contentTitle), 'facebook share dialog', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            },
            sendLinkTwitter() {
                window.open('https://twitter.com/intent/tweet?text=%20' +encodeURIComponent(this.viewUrl)+'%20-%20'+encodeURIComponent(this.contentTitle), 'twitter share dialog', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            },
            sendLinkNaver() {
                window.open('https://share.naver.com/web/shareView.nhn?url=' + encodeURI(encodeURIComponent(this.viewUrl))+'&title='+encodeURI(this.contentTitle), 'naver share dialog', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=410');
            },
            sendLinkKakao() {
                Kakao.init('6740ced26ed4a4673b47bd8f0391518e');
                Kakao.Story.share({
                    url: this.viewUrl
                });
            },
            copyLink() {
                let shortUrlToCopy = document.querySelector('#short-url');
                shortUrlToCopy.setAttribute('type', 'text');

                if (navigator.userAgent.match(/ipad|iphone/i)) {
                    var range = document.createRange();
                    range.selectNodeContents(shortUrlToCopy);
                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                    shortUrlToCopy.setSelectionRange(0, 999999);
                } else {
                    shortUrlToCopy.select();
                }

                try {
                    var successful = document.execCommand('copy');
                    if(successful)
                        alert('단축 URL 주소('+this.shortUrl+')가 복사되었습니다.');
                    else
                        alert('복사하지 못하였습니다.');
                } catch(err) {
                    //console.log(err);
                    alert('이 브라우저는 지원하지 않습니다.')
                }

                shortUrlToCopy.setAttribute('type', 'hidden');
                window.getSelection().removeAllRanges();
            },
            qrcodeMake(url) {
                $("#qrcode").empty();
                var qrcode = new QRCode(document.getElementById("qrcode"), {
                    width: 200,
                    height: 200,
                    colorDark : "#000000",
                    colorLight : "#ffffff",
                    correctLevel : QRCode.CorrectLevel.H
                });
                qrcode.makeCode(url);
            }
        }
    }
</script>